<!-- src/components/Footer.vue -->
<template>
  <div class="footer">
    <!-- 上部区域 -->
    <div class="footer-top main-container">
      <!-- Logo 和导航栏 -->
      <div class="logo-nav-container">
        <div class="logo-container">
          <img :src="logoUrl" alt="Healthcode Logo" class="logo" />
        </div>

        <div class="nav-links">
          <a href="" class="nav-link">      <router-link to="/about" @click.prevent>
             {{ t("footer.about") }}
       </router-link></a>
          <a href="https://www.ourproteinfactory.com/" target="_blank" class="nav-link">{{
            t("footer.proteinFactory")
          }}</a>
         <a href="https://www.d2plab.com" target="_blank" class="nav-link">{{
            t("footer.d2pLabs")
          }}</a>
             <a href="https://www.ystemed.com/home" target="_blank" class="nav-link">{{
            t("footer.cosmeticMedicine")
          }}</a>
          
           <a href="https://www.thelightofdesert.com" target="_blank" class="nav-link">{{
            t("footer.proteinConcentrate")
          }}</a>
          <a href="mailto:hr@healthcodon.com" class="nav-link">{{ t("footer.careers") }}</a>
         
        </div>
      </div>

      <div class="top-right">
        <div class="contact-info">
          <div class="contact-item">
            <div class="titles">
              <div class="icon">
                <svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
                  <path
                    d="M14.4446 6.05577C14.4446 3.60466 12.4512 1.61133 10.0001 1.61133C7.549 1.61133 5.55566 3.60466 5.55566 6.05577C5.55566 8.22133 7.11344 10.0247 9.16678 10.4158V15.2224C9.16678 15.6824 9.54011 16.0558 10.0001 16.0558C10.4601 16.0558 10.8334 15.6824 10.8334 15.2224V10.4158C12.8868 10.0236 14.4446 8.22133 14.4446 6.05577Z"
                    fill="white" fill-opacity="0.8" />
                  <path
                    d="M9.99997 19.3888C6.69886 19.3888 1.11108 18.7454 1.11108 16.3332C1.11108 14.5432 4.07553 13.7954 6.56331 13.4832C7.01775 13.4254 7.43664 13.7499 7.49331 14.2066C7.55108 14.6632 7.22664 15.0799 6.76997 15.1366C4.25442 15.4532 3.07886 16.0388 2.8122 16.3343C3.21775 16.7943 5.59219 17.7232 9.99886 17.7232C14.4055 17.7232 16.78 16.7943 17.1855 16.3343C16.9189 16.0388 15.7444 15.4532 13.2278 15.1366C12.7711 15.0788 12.4466 14.6621 12.5044 14.2066C12.5622 13.7499 12.9822 13.4254 13.4344 13.4832C15.9222 13.7954 18.8866 14.5443 18.8866 16.3332C18.8866 18.7454 13.2989 19.3888 9.99775 19.3888H9.99997Z"
                    fill="white" fill-opacity="0.8" />
                </svg>
              </div>
              <div class="label">{{ t("footer.address") }}:</div>
            </div>

            <div class="value">
              <span>{{ t("footer.add1") }}</span>
              <span>{{ t("footer.add4") }}</span>
              <span>{{ t("footer.add2") }}</span>
              <span>{{ t("footer.add3") }}</span>
            </div>
          </div>
          <div class="contact-item">
            <div class="titles">
              <span class="icon"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                  xmlns="http://www.w3.org/2000/svg" class="icon">
                  <path
                    d="M14.375 2.29199H5.62502C4.5752 2.29199 3.56839 2.70903 2.82606 3.45136C2.08372 4.19369 1.66669 5.20051 1.66669 6.25033V13.7503C1.66669 14.2701 1.76907 14.7849 1.968 15.2651C2.16692 15.7454 2.45849 16.1817 2.82606 16.5493C3.56839 17.2916 4.5752 17.7087 5.62502 17.7087H14.375C15.4242 17.7065 16.4297 17.2887 17.1716 16.5469C17.9134 15.805 18.3312 14.7995 18.3334 13.7503V6.25033C18.3312 5.20119 17.9134 4.19565 17.1716 3.45379C16.4297 2.71194 15.4242 2.29419 14.375 2.29199ZM11.3334 9.22533C10.9234 9.45915 10.4595 9.58212 9.98752 9.58212C9.51553 9.58212 9.05169 9.45915 8.64169 9.22533L2.93335 5.95033C3.00716 5.28808 3.32253 4.67628 3.81912 4.23196C4.31571 3.78765 4.95867 3.54199 5.62502 3.54199H14.375C15.0409 3.54382 15.6828 3.7901 16.179 4.23408C16.6752 4.67805 16.9911 5.28879 17.0667 5.95033L11.3334 9.22533Z"
                    fill="white" fill-opacity="0.8" />
                </svg></span>
              <span class="label">{{ t("footer.email") }}:</span>
            </div>

         <div class="value"><a href="mailto:contact@healthcodon.com">contact@healthcodon.com</a></div>
          </div>
        </div>

        <!-- 社交媒体 -->
<div class="social-media">
    <span class="follow-text">{{ t("footer.followUs") }}</span>
    <div class="social-icons">
      <div class="social-icon-wrapper">
        <a  class="social-icon" aria-label="Douban">
          <img class="icon icon-bot" src="../assets/image/home/wxchanal.png" alt="Douban" />
        </a>
        <div class="qr-code-popup">
          <img src="../assets/image/home/qrcode-wechat.png" alt="Douban QR Code" class="qr-code-image" />
        </div>
      </div>
      

      <div class="social-icon-wrapper">
        <a class="social-icon" aria-label="WeChat">
          <img class="icon icon-bot1" src="../assets/image/home/bilibili.png" alt="WeChat" />
        </a>
        <div class="qr-code-popup">
          <img src="../assets/image/home/qrcode-bilibili.png" alt="WeChat QR Code" class="qr-code-image" />
        </div>
      </div>
      
      <div class="social-icon-wrapper">
        <a class="social-icon" aria-label="TikTok">
          <img class="icon" src="../assets/image/home/tiktok.webp" alt="TikTok" />
        </a>
        <div class="qr-code-popup">
          <img src="../assets/image/home/qrcode-tiktok.png" alt="TikTok QR Code" class="qr-code-image" />
        </div>
      </div>
    </div>
  </div>
      </div>
    </div>
    <!-- 底部区域 -->
    <div class="footer-bottom main-container">
      <div class="copyright">
        <span>{{ t("footer.copyright") }}</span>
      </div>
      <div class="legal-links">
        <div class="icp-group">
          <a href="https://beian.miit.gov.cn/" class="legal-link">{{ icpText }}</a>
          <a href="#" class="legal-link">{{ securityText }}</a>
        </div>
        <a href="#" class="legal-link">{{ t("footer.privacy") }}</a>
        <a href="#" class="legal-link">{{ t("footer.terms") }}</a>
        <a href="#" class="legal-link">{{ t("footer.sales") }}</a>
        <a href="#" class="legal-link">{{ t("footer.law") }}</a>
        <a href="#" class="legal-link">{{ t("footer.sitemap") }}</a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import logoUrl from "../assets/image/logo.png";

const { locale, t } = useI18n();

// 根据域名确定显示的安全备案文本
const securityText = computed(() => {
  const hostname = window.location.hostname;
  if (hostname.includes('healthcode.com')) {
    return t("footer.icp");
  } else if (hostname.includes('healthcodon.com')) {
    return t("footer.icp1");
  }
  return t("footer.icp"); // 默认值
});

const icpText = computed(() => {
  const hostname = window.location.hostname;
  if (hostname.includes('healthcode.com')) {
    return t("footer.security");
  } else if (hostname.includes('healthcodon.com')) {
    return t("footer.securityType1");
  }
  return t("footer.security"); // 默认值
});
</script>

<style scoped>
.footer {
  background-color: #323232;
  color: #ffffff;
  padding: 2rem 0;
  width: 100%;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-block: 2rem;
  gap:1rem;
}

.logo-nav-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 40rem;
}

.logo-container {
  flex: 1;
}

.logo {
  height: 3.6rem;
}

.nav-links {
  flex: 1;
  display: flex;
  gap: 1.2rem;
}

.nav-link {
  color: #ffffff;
  text-decoration: none;
  font-size: 1rem;
  transition: all 0.3s ease;
  display: inline-block;
  overflow: hidden;
  position: relative;
}

.nav-link:hover {
  transform: translateY(-3px);
}

.nav-link::before {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #007bff;
  transition: width 0.3s ease;
}

.nav-link:hover::before {
  width: 100%;
}

.top-right {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 2rem;
}

.contact-info {
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 2rem;
}

.contact-item {
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  justify-content: flex-start;
}

.contact-item .titles {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.contact-item .icon {
  font-size: 1rem;
  width: 1.2rem;
}

.contact-item .label {
  font-size: 0.9rem;
  opacity: 0.8;
}

.contact-item .value {
  font-size: 0.9rem;
  display: flex;
  flex-direction: column;
}

.social-media {
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1rem;
}

.follow-text {
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  opacity: 0.8;
}

.social-icons {
  display: flex;
  gap: 1rem;
}

.social-icon {
  align-items: center;
  border: 1px solid hsla(0, 0%, 100%, 0.1);
  border-radius: 2.4rem;
  display: flex;
  flex-direction: row;
  height: 2.8rem;
  justify-content: center;
  transition: background 0.3s ease;
  width: 4.8rem;
  cursor: pointer;
}

.social-icon img {
  height: 1.7rem;
}
.social-icon .icon-bot{
  height: 2.6rem;

}
.social-icon .icon-bot1{
  height: 2.8rem;
}

.social-icon:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  padding: 2rem 6rem 0 6rem;
  font-size: 0.8rem;
  opacity: 0.8;
}

.legal-links {
  display: flex;
  gap: 1rem;
}

.legal-link {
  color: #ffffff;
  text-decoration: none;
  transition: color 0.3s ease;
}

.icp-group{
    display: flex;
    gap: 0.6rem;
}
.social-icon-wrapper {
  position: relative;
  display: inline-block;
}
.qr-code-popup {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 10px;
  background: white;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 100;
  width: 12rem;
  height: 12rem;
}

.social-icon-wrapper:hover .qr-code-popup {
  opacity: 1;
  visibility: visible;
}

.qr-code-image {
  width: 10rem;
  height: 10rem;
  margin: 0 auto;
  overflow: hidden;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .footer-top {
    flex-direction: column;
    gap: 1rem;
  }

  .nav-links,
  .contact-info,
  .social-media {
    margin: 0;
    flex: none;
  }

  .social-media {
    align-items: flex-start;
  }
}

@media (max-width: 768px) {
  .icp-group {
        display: flex;
        flex-wrap: wrap;
        gap: 0.2rem;
        width: 100%;
        justify-content: center;
  }

  .icp-group .legal-link {
    white-space: nowrap;
  }


  .logo-nav-container {
    align-items: center;
    order: -1;
    padding: 1rem 2rem;
  }

  .social-icon img {
    height: 2.6rem;
  }

  .follow-text {
    font-size: 1.6rem;
  }

  .social-icon {
    align-items: center;
    border: 1px solid hsla(0, 0%, 100%, 0.1);
    border-radius: 2.4rem;
    display: flex;
    flex-direction: row;
    height: 3.8rem;
    justify-content: center;
    transition: background 0.3s ease;
    width: 10rem;
  }

  .footer {
    padding: 3rem 2rem;
  }

  .footer-top {
    padding: 0 1rem;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 2rem;
  }

  .logo-nav-container {
    align-items: center;
  }

  .nav-links {
    flex-wrap: wrap;
    gap: 0 2rem 0 2rem;
    justify-content: center;
    line-height: 2rem;
  }

  .top-right {
    align-items: center;
  }

  .contact-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 1.5rem;
    border: 1px solid hsla(0, 0%, 100%, 0.2);
    border-radius: 0.8rem;
    display: block;
    font-size: 1.6rem;
    order: 1;
    padding: 1.6rem;
    margin-top: 1rem;
  }

  .contact-item:not(:last-child) {
    align-items: flex-start;
    margin-bottom: 2rem;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.2);
    padding-bottom: 1.6rem;
  }

  .social-media {
    align-items: center;
    flex-direction: column;
  }

  .social-icons {
    gap: 0.8rem;
    justify-content: center;
  }

  .footer-bottom {
    flex-direction: column;
    align-items: center;
    gap: 0rem;
    padding: 0.5rem;
    text-align: center;
    font-size: 1.2rem;
    border-top: none;
    margin-top: 1.5rem;
  }

  .legal-links {
    flex-wrap: wrap;
    gap: 0.8rem;
    justify-content: center;
  }

  .copyright {
    text-align: center;
  }

  .contact-item .value {
    font-size: 1.2rem;
    text-align: left;
    color: #e5e7eb;
  }

  .nav-link {
    font-size: 1.4rem;
    color: #e5e7eb;
  }

  .contact-item .label {
    font-size: 1.2rem;
    color: #e5e7eb;
  }

  .logo {
    height: 4.8rem;
  }

  .logo-container {
    flex: 1;
    margin-bottom: 2rem;
  }
   .qr-code-popup {
    position: absolute;
    top: -140px;
    left: 50%;
    transform: translateX(-50%);
    width: 12rem;
    height: 12rem;
  }
  .qr-code-image {
    width: 100%;
    height: 100%;
  }
  .social-icon .icon-bot{
    height: 3.4rem;
  }
    .social-icon .icon-bot1{
    height: 3.8rem;
  }
}
</style>
